import React, { createContext, useContext } from 'react';
export const CurrSubscriptionContext = createContext<any>({ currentSub: { id: 1 } });
export const CurrSubscriptionProvider = ({ children }: any) => (
  <CurrSubscriptionContext.Provider value={{ currentSub: { id: 1 } }}>
    {children}
  </CurrSubscriptionContext.Provider>
);
